import { render, staticRenderFns } from "./PedirRepuestosBodega.vue?vue&type=template&id=0bd09e93&lang=pug"
import script from "./PedirRepuestosBodega.vue?vue&type=script&lang=js"
export * from "./PedirRepuestosBodega.vue?vue&type=script&lang=js"
import style0 from "./PedirRepuestosBodega.vue?vue&type=style&index=0&id=0bd09e93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports